import React, { FC, useMemo } from 'react';
import { WelcomeBoxButton as WelcomeBoxButtonPk, redirectTo } from 'omni-package-react-core';
import { useNavigate } from 'react-router-dom';
import { EmailIcon, useScopedSelector } from 'ia-react-core';
import Constants from '../../Constants';
import { MessagingSummaryResourceInfo } from '../MessagingSummaryResource/MessagingSummaryResource';

export interface WelcomeBoxButtonProps { }

const WelcomeBoxButton: FC<WelcomeBoxButtonProps> = () => {
  const navigate = useNavigate();
  const newMessageCount: number = useScopedSelector(MessagingSummaryResourceInfo.dataDst);
  const count = useMemo(() => newMessageCount > 0 ? (newMessageCount) : null, [newMessageCount]);
  if (count <= 0) return null;

  return (
    <WelcomeBoxButtonPk
      data-testid="Messages"
      LeftIcon={EmailIcon}
      onClick={() => { redirectTo(Constants.BasePagePath, navigate); }}
      count={count}
      singular="message"
      plural="messages"
    />
  );
};

export default WelcomeBoxButton;
